// extracted by mini-css-extract-plugin
export var banner = "Banner_banner__C5Qol";
export var bannerInner = "Banner_bannerInner__+uN0R";
export var header = "Banner_header__kr-Fb";
export var bg = "Banner_bg__IU3Gj";
export var button = "Banner_button__euHWv";
export var rotate = "Banner_rotate__YDEjR";
export var dotty = "Banner_dotty__jK910";